import { render, staticRenderFns } from "./remittance.vue?vue&type=template&id=6701f3c6&scoped=true"
import script from "./remittance.vue?vue&type=script&lang=js"
export * from "./remittance.vue?vue&type=script&lang=js"
import style0 from "./remittance.vue?vue&type=style&index=0&id=6701f3c6&prod&lang=scss&scoped=true"
import style1 from "./remittance.vue?vue&type=style&index=1&id=6701f3c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701f3c6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pay/remittance.vue
// module id = null
// module chunks = 